import { fileManagerRestrictionLocale } from "../../widget/file-manager/locale/en_US.js";
import { languagePairLocale } from "../../widget/language-pair/locale/en_US.js";
import { calendarLocale } from "../calendar/locale/en_US.js";
import { carouselLocale } from "../carousel/locale/en_US.js";
import { cascaderLocale } from "../cascader/locale/en_US.js";
import { datePickerLocale } from "../date-picker/locale/en_US.js";
import { emptyLocale } from "../empty/locale/en_US.js";
import { paginationLocale } from "../pagination/locale/en_US.js";
import { sidebarLocale } from "../sidebar/locale/en_US.js";
import { tagSelectorLocale } from "../tag-selector/locale/en_US.js";
const locale = {
  locale: "en-US",
  global: {
    cancelText: "Cancel",
    closeText: "Close",
    moreText: "More",
    okText: "OK"
  },
  // ui
  calendar: calendarLocale,
  carousel: carouselLocale,
  cascader: cascaderLocale,
  datePicker: datePickerLocale,
  empty: emptyLocale,
  pagination: paginationLocale,
  sidebar: sidebarLocale,
  tagSelector: tagSelectorLocale,
  // widget
  languagePair: languagePairLocale,
  useFileManager: fileManagerRestrictionLocale
};
export {
  locale as default
};
//# sourceMappingURL=en_US.js.map
